import React from "react";
import apiService from "../../services/apiService";
import "fabric-webpack";
import jsPDF from "jspdf";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";

import { useSearchParams } from "react-router-dom";

//service
import { postCertificate } from "../../services/download";

//Imports de components
import {
  Container,
  FormRow,
  FormColumn,
  InputFieldOutlined,
  Dialog,
} from "../../components";
import FabricCanvasDesign from "./FabricCanvasDesign";
import FabricCanvasImage from "./FabricCanvasImage";
import FabricCanvasText from "./FabricCanvasText";

const UserCertificatePage = (props) => {
  const [state, setState] = React.useState(false);
  const [colorBackground, setColorBackground] = React.useState("transparent");
  const [buttonConfig, setButtonConfig] = React.useState({
    colorButton: "#3f51b5",
    colorTextButton: "white",
  });
  const [userEditName, setUserEditName] = React.useState();
  const [textConfig, setTextConfig] = React.useState({
    text: props.userName.substring(0, 45),
    left: props.namePositionWidth,
    top: props.namePositionHeigth,
    textColor: props.fontColor,
    textFontSize: props.fontSize,
    textFontType: "verdana",
    nameAlign: props.nameAlign,
  });
  const [imageConfig, setImageConfig] = React.useState({
    image: `${apiService.getUrl().corsAnywhere}${props.image}`,
  });
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [isEditing, setIsEditing] = React.useState(false);
  const [imageToDownload, setImageToDownload] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [rotateCanvas, setRotateCanvas] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggleRotate = () => setRotateCanvas((prevState) => !prevState);

  const imgRef = React.useRef(null);

  React.useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    if (img.complete && img.naturalWidth > 0) {
      resizeCanvas();
    } else {
      img.onload = () => {
        const isInApp = typeof window.ReactNativeWebView !== "undefined";
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const isMobileOrApp = isInApp || isMobile;

        setIsMobile(isMobileOrApp);
        const _canvas = document.getElementById("certificate");
        const _image = document.getElementById("real-image");

        if (!_canvas || !_image) return;

        _canvas.width = _image.naturalWidth;
        _canvas.height = _image.naturalHeight;

        let scaledWidth = _canvas.width >= 1000 ? 1000 : _canvas.width;

        if (isMobileOrApp) {
          scaledWidth = 90;
          // scaledHeight = 50;
          _canvas.style.width = `${scaledWidth}%`;
          _canvas.style.height = `auto`;
          _canvas.style.marginLeft = "5%";
        }

        const ctx = _canvas.getContext("2d");
        if (ctx) {
          ctx.clearRect(0, 0, _canvas.width, _canvas.height);
          ctx.drawImage(_image, 0, 0);

          ctx.font = `${props.fontSize}px Verdana`;
          ctx.fillStyle = props.fontColor || "black";
          ctx.textAlign = getAlign(props.nameAlign) || "left";
          ctx.textBaseline = "top";
          ctx.fillText(
            props.userName.substring(0, 45),
            props.namePositionWidth,
            props.namePositionHeigth + 4.8
          );
        }
      };
    }
  }, []);

  const getAlign = (align) => {
    if (align === "Centro") return "center";
    if (align === "Esquerda") return "left";
    if (align === "Direita") return "right";
  };

  const resizeCanvas = () => {
    const isInApp = typeof window.ReactNativeWebView !== "undefined";
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isMobileOrApp = isInApp || isMobile;

    setIsMobile(isMobileOrApp);

    const _canvas = document.getElementById("certificate");
    const _image = document.getElementById("real-image");

    if (_canvas && _canvas.style && _image && _image.naturalWidth > 0) {
      const imgWidth = _image.naturalWidth;
      const imgHeight = _image.naturalHeight;

      _canvas.width = imgWidth;
      _canvas.height = imgHeight;

      let scaledWidth = imgWidth >= 1000 ? 1000 : imgWidth;
      let scaledHeight = imgHeight >= 550 ? 550 : imgHeight;

      if (isMobileOrApp) {
        scaledWidth = 90;
        // scaledHeight = 50;
        _canvas.style.width = `${scaledWidth}%`;
        _canvas.style.height = `auto`;
        _canvas.style.marginLeft = "5%";
      } else {
        _canvas.style.width = `${scaledWidth}px`;
        _canvas.style.height = `${scaledHeight}px`;
      }
      _canvas.style.display = "block";
      _canvas.style.margin = "20 auto";

      // // Redesenha a imagem no canvas real
      const ctx = _canvas.getContext("2d");
      if (ctx) {
        ctx.clearRect(0, 0, imgWidth, imgHeight);
        ctx.drawImage(_image, 0, 0, imgWidth, imgHeight);
      }
    }
    setTextConfig((prev) => ({
      ...prev,
      text: props.userName.substring(0, 45),
      left: props.namePositionWidth,
      top: props.namePositionHeigth,
      textColor: props.fontColor,
      textFontSize: props.fontSize,
      textFontType: "verdana",
      nameAlign: props.nameAlign,
    }));
  };

  const downloadCanvasAsPDF = async () => {
    const canvas = document.getElementById("certificate");
    if (!canvas || !canvas.toDataURL) {
      console.error("Canvas não encontrado.");
      return;
    }

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const base64Image = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF({
      orientation: canvasWidth > canvasHeight ? "landscape" : "portrait",
      unit: "pt",
      format: [canvasWidth, canvasHeight],
    });

    pdf.addImage(base64Image, "JPEG", 0, 0, canvasWidth, canvasHeight);

    // const pdfBase64 = pdf.output("datauristring");
    const pdfBase64 = pdf.output("dataurlstring", { base64: true });

    if (window.ReactNativeWebView) {
      const dateNow = new Date().toISOString().replace(/[:.]/g, "-");
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          message: "base64ToDownload",
          data: pdfBase64,
          name: `Certificado-${dateNow}.pdf`,
        })
      );
    } else {
      pdf.save("Certificado.pdf");
    }

    try {
      await postCertificate(
        props.canvas.idEvent,
        props.canvas.idPart,
        props.canvas.idCertificate
      );
    } catch (err) {
      console.error("Erro ao registrar certificado:", err);
    }
  };

  const downloadCanvasAsJPEG = async () => {
    const canvas = document.getElementById("certificate");
    if (!canvas || !canvas.toDataURL) {
      console.error("Canvas não encontrado.");
      return;
    }

    const base64Image = canvas.toDataURL("image/jpeg", 1.0);

    if (window.ReactNativeWebView) {
      const dateNow = new Date().toISOString().replace(/[:.]/g, "-");
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          message: "base64ToDownload",
          data: base64Image,
          name: `Certificado-${dateNow}.jpeg`,
        })
      );
    } else {
      const link = document.createElement("a");
      link.href = base64Image;
      link.download = "Certificado.jpeg";
      link.click();
    }

    try {
      await postCertificate(
        props.canvas.idEvent,
        props.canvas.idPart,
        props.canvas.idCertificate
      );
    } catch (err) {
      console.error("Erro ao registrar certificado:", err);
    }
  };

  const saveUserName = () => {
    var _textConfig = textConfig;
    _textConfig.text = userEditName;
    setTextConfig(_textConfig);
    setDialogOpen(false);
    setIsEditing(false);
  };

  return (
    <Container
      background={colorBackground}
      align="center"
      backgroundSize="100% 100%"
      height="100%"
    >
      <FormColumn align="center" background={colorBackground} margin="0px">
        <FormRow
          align="center"
          background="transparent"
          margin="0px"
          style={{
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 10,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
              padding: 5,
              borderRadius: 4,
            }}
          >
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle caret color="primary">
                Baixar
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={downloadCanvasAsJPEG}>
                  Imagem (jpeg)
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={downloadCanvasAsPDF}>PDF</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          {isMobile && (
            <div
              style={{
                position: "absolute",
                top: 14,
                right: "5%",
                zIndex: 10,
              }}
            >
              <Button
                color="primary"
                onClick={toggleRotate}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "8px 12px",
                }}
              >
                <i
                  className="bx bx-rotate-right"
                  style={{
                    color: "white",
                    fontSize: 20,
                    cursor: "pointer",
                  }}
                />
              </Button>
            </div>
          )}
        </FormRow>

        {!isEditing && (
          <FormRow
            align="center"
            background="transparent"
            margin="0px"
            paddingTop="60px"
          >
            <img
              crossOrigin="anonymous"
              id="real-image"
              src={imageConfig.image}
              ref={imgRef}
              alt="Real Size"
              style={{
                display: "none",
              }}
            />
            <FabricCanvasDesign key="1" rotateCanvas={rotateCanvas}>
              <FabricCanvasText
                text={textConfig.text}
                left={textConfig.left}
                top={textConfig.top}
                color={textConfig.textColor}
                fontSize={textConfig.textFontSize}
                fontType={textConfig.textFontType}
                nameAlign={textConfig.nameAlign}
              />
              <FabricCanvasImage url={imageConfig.image} scale={1} top={0} />
            </FabricCanvasDesign>
            <svg id="pdfSvg" xmlns="http://www.w3.org/2000/svg" />
          </FormRow>
        )}
      </FormColumn>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        title="Nome"
        textButtonYes="Salvar"
        textButtonNo="Cancelar"
        onClickYes={saveUserName}
        onClickNo={() => {
          setDialogOpen(false);
          setIsEditing(false);
        }}
      >
        <FormRow align="center" paddingTop="5px">
          <InputFieldOutlined
            key="name"
            value={userEditName}
            onChange={(event) => setUserEditName(event.target.value)}
            maxLength={45}
          />
        </FormRow>
      </Dialog>
    </Container>
  );
};

export default UserCertificatePage;
